/* Fabric Guide Filter */

class FabricGuideFilter extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const filterButtons = this.querySelectorAll(".filter-buttons-js");
    const productsContainers = this.querySelectorAll(".product-container-js");
    const navigationFabricGuideContainer =
      document.querySelector(".scroll-target-js");

    filterButtons.forEach((filterButton) => {
      filterButton.addEventListener("click", () => {
        const positionTop =
          navigationFabricGuideContainer.getBoundingClientRect().top;

        window.scrollBy({
          top: positionTop - 85,
          behavior: "instant",
        });

        filterButtons.forEach((btn) => {
          btn.classList.add("opacity-60");
        });

        productsContainers.forEach((productContainer) => {
          productContainer.classList.add("hidden");

          if (productContainer.dataset.product === filterButton.innerHTML) {
            productContainer.classList.remove("hidden");
            filterButton.classList.remove("opacity-60");
          }

          if (filterButton.innerHTML === "All Styles") {
            productContainer.classList.remove("hidden");
            filterButton.classList.remove("opacity-60");
          }
        });
      });
    });
  }
}

customElements.define("fabric-filtered", FabricGuideFilter);
